import { useMutation } from "react-query";
import { grantFreeOffer } from "@/api/purchase.ts";
import { AxiosError } from "axios";

export const useGrantFreeOffer = () => {
  return useMutation<{ url: string }, AxiosError, { sourceProductId: string }>(
    ({ sourceProductId }) => {
      return grantFreeOffer(sourceProductId);
    },
  );
};
